<nb-card>
  <nb-card-header>
    Profil & Sécurité
  </nb-card-header>
  <nb-card-body>
    <h4>Double Authentification (2FA)</h4>
    
    <div *ngIf="is2FAEnabled; else setupBlock">
      <nb-alert status="success" class="mb-3">
        <nb-icon icon="checkmark-circle-outline"></nb-icon> La double authentification est activée.
      </nb-alert>
      
      <button nbButton status="danger" (click)="disable2FA()">Désactiver la 2FA</button>
    </div>

    <ng-template #setupBlock>
      <div *ngIf="!qrCode">
        <p>Protégez votre compte en activant la double authentification.</p>
        <button nbButton status="primary" (click)="setup2FA()">Activer la 2FA</button>
      </div>

      <div *ngIf="qrCode" class="setup-container">
        <h5>Configuration</h5>
        <p>1. Scannez ce QR Code avec votre application d'authentification (Google Authenticator, etc.)</p>
        <img [src]="qrCode" alt="QR Code" style="max-width: 200px; margin: 1rem 0;">
        
        <p>2. Entrez le code généré par l'application :</p>
        <div class="form-group row">
            <div class="col-sm-6">
                <input type="text" nbInput fullWidth placeholder="Code à 6 chiffres" [(ngModel)]="verificationCode">
            </div>
            <div class="col-sm-6">
                 <button nbButton status="success" (click)="confirm2FA()" [disabled]="!verificationCode">Confirmer</button>
            </div>
        </div>
      </div>
    </ng-template>

  </nb-card-body>
</nb-card>
